import { AdminLayout } from "@/components/layout/AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const mockData = [
  {
    id: 1,
    classification: "Books",
    category: "Religious",
    word: "Pratikraman",
    synonym1: "Pratikraman",
    synonym2: "Repentance",
  },
  {
    id: 2,
    classification: "Books",
    category: "Religious",
    word: "Pooja",
    synonym1: "Worship",
    synonym2: "Prayer",
  },
];

const SynonymWord = () => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState("All");

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="mb-2 text-3xl font-bold text-foreground">
              User Synonymword
            </h2>
            <div className="text-sm">
              <span className="text-muted-foreground">Record Count</span>
              <div className="text-lg font-semibold">89</div>
            </div>
          </div>
          <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
            Export Data
          </Button>
        </div>

        {/* Alphabet Filter */}
        <div className="flex flex-wrap gap-2">
          <Button
            variant={selectedLetter === "All" ? "default" : "outline"}
            size="sm"
            onClick={() => setSelectedLetter("All")}
            className="h-8"
          >
            All
          </Button>
          {alphabet.map(letter => (
            <Button
              key={letter}
              variant={selectedLetter === letter ? "default" : "outline"}
              size="sm"
              onClick={() => setSelectedLetter(letter)}
              className="h-8 w-8 p-0"
            >
              {letter}
            </Button>
          ))}
        </div>

        {/* Search Section */}
        <div>
          <div className="mb-2 text-sm font-medium">Search</div>
          <div className="flex gap-2">
            <Button variant="outline" size="sm">
              All
            </Button>
            <Button variant="outline" size="sm">
              City
            </Button>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-hidden rounded-lg border border-border bg-card">
          <table className="w-full">
            <thead className="bg-muted/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  SR.NO.
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Classification
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Main Word
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Synonym 1
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Synonym 2
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Synonym
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {mockData.length === 0 ? (
                <tr>
                  <td
                    colSpan={7}
                    className="px-6 py-8 text-center text-muted-foreground"
                  >
                    No data available
                  </td>
                </tr>
              ) : (
                mockData.map((item, index) => (
                  <tr key={item.id} className="hover:bg-muted/30">
                    <td className="px-6 py-3 text-sm">{index + 1}</td>
                    <td className="px-6 py-3 text-sm">{item.classification}</td>
                    <td className="px-6 py-3 text-sm">{item.category}</td>
                    <td className="px-6 py-3 text-sm">{item.word}</td>
                    <td className="px-6 py-3 text-sm">{item.synonym1}</td>
                    <td className="px-6 py-3 text-sm">{item.synonym2}</td>
                    <td className="px-6 py-3 text-sm">-</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-center gap-2">
          <Button variant="outline" size="sm">
            « First
          </Button>
          <Button variant="outline" size="sm">
            ‹ Back
          </Button>
          <Button size="sm" className="bg-primary text-primary-foreground">
            1
          </Button>
          <Button variant="outline" size="sm">
            Next ›
          </Button>
          <Button variant="outline" size="sm">
            Last »
          </Button>
        </div>
      </div>

      {/* Add Synonym Dialog */}
      <Dialog open={addDialogOpen} onOpenChange={setAddDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Add Synonym</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label required>Word</Label>
              <Input placeholder="Enter word" />
            </div>
            <div>
              <Label required>Synonyms (comma separated)</Label>
              <Input placeholder="Enter synonyms" />
            </div>
          </div>
          <DialogFooter>
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
              Save
            </Button>
            <Button variant="outline" onClick={() => setAddDialogOpen(false)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={editDialogOpen} onOpenChange={setEditDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Synonym</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label required>Word</Label>
              <Input defaultValue="Happy" />
            </div>
            <div>
              <Label required>Synonyms (comma separated)</Label>
              <Input defaultValue="Joyful, Cheerful, Content" />
            </div>
          </div>
          <DialogFooter>
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
              Save
            </Button>
            <Button variant="outline" onClick={() => setEditDialogOpen(false)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </AdminLayout>
  );
};

export default SynonymWord;
